import React from "react";
import "./App.css";
import AppRoutes from "./app/routes";
import PersistLogin from "./hooks/PersistLogin";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
